const SUPPORTED_BLOCKS = ['core/post-featured-image', 'core/cover'];

/**
 * Adds the mediaPressMediaFeaturedImageVariation attribute to block settings
 * so that it can be stored in the block attributes.
 *
 * @param  {Object} settings Block settings
 *
 * @return {Object}          Modified block settings
 */
function addFeaturedImageVariationAttribute(settings) {
  if (!SUPPORTED_BLOCKS.includes(settings.name)) {
    return settings;
  }

  const newSettings = {
    ...settings,
    attributes: {
      ...settings.attributes,
      mediaPressMediaFeaturedImageVariation: {
        type: 'string',
        default: null,
      },
    },
  };

  return newSettings;
}

export default addFeaturedImageVariationAttribute;
